/**
 * Footer legal/contact entries. Each stays a plain label until the owner
 * supplies a real destination (set href to the confirmed URL or mailto:).
 */
export interface LegalLink {
  label: string
  href: string | null
}

export const legalLinks: LegalLink[] = [
  { label: 'Mentions légales', href: null },
  { label: 'Confidentialité', href: null },
  { label: 'Contact', href: null },
]
